import { NotificationCard } from '../../../shared/NotificationCard';
import { PageLayout } from '../../../shared/PageLayout';
import { useQuotationNotification } from './useQuotationNotification';
import styles from './quotation-notification.module.css';
import { QuotationNotificationResponse } from './interface';
import { Loading } from '../../../shared/Loading';
import { NotificationModal } from './components/NotificationModal';

export const QuotationNotification = () => {
  const {
    setSelectedNotification,
    isLoading,
    readQuotationNotification,
    notifications,
    selectedNotification,
  } = useQuotationNotification();

  const handleRedirect = (notification: QuotationNotificationResponse) => {
    setSelectedNotification(notification);
    if (!notification.read) {
      readQuotationNotification();
    }
  };

  return (
    <>
      <NotificationModal
        isOpen={!!selectedNotification}
        notification={selectedNotification}
        onClose={() => setSelectedNotification(null)}
      />
      <PageLayout.Root title="Notificações das Cotações">
        <ul className={styles['notifications-list']}>
          {isLoading && notifications.length === 0 && (
            <>
              <Loading
                style={{
                  height: '8rem',
                }}
              />
              <Loading
                style={{
                  height: '8rem',
                }}
              />
              <Loading
                style={{
                  height: '8rem',
                }}
              />
              <Loading
                style={{
                  height: '8rem',
                }}
              />
            </>
          )}
          {notifications.map(notification => (
            <NotificationCard.Root
              key={notification.id_notification}
              datetime={notification.created_at}
              title={notification?.title ?? 'Atualização da cotação'}
              message={notification.message}
              variant={notification.type}
              onClick={() => handleRedirect(notification)}
            />
          ))}
        </ul>
      </PageLayout.Root>
    </>
  );
};
